import { APP_CONFIG } from '@constants';

const upload = require('superagent');

export const UPLOAD_IMAGE_REQUESTED = 'upload/UPLOAD_IMAGE_REQUESTED';
export const UPLOAD_IMAGE_SUCCESS = 'upload/UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_FAILURE = 'upload/UPLOAD_IMAGE_FAILURE';

export const SAVE_CONFIG_REQUESTED = 'saveWallet/SAVE_CONFIG_REQUESTED';
export const SAVE_CONFIG_SUCCESS = 'saveWallet/SAVE_CONFIG_SUCCESS';
export const SAVE_CONFIG_FAILURE = 'saveWallet/SAVE_CONFIG_FAILURE';

export const UPDATE_TITLE_FIELD = 'customeventdefaultUPDATE_TITLE_FIELD';
export const UPDATE_SUBTITLE_FIELD = 'customeventdefaultUPDATE_SUBTITLE_FIELD';
export const UPDATE_TEMPLATE_FIELD = 'customeventdefaultUPDATE_TEMPLATE_FIELD';

export const GET_CONFIG_REQUESTED = 'customeventdefaultGET_CONFIG_REQUESTED';
export const GET_CONFIG_SUCCESS = 'customeventdefaultGET_CONFIG_SUCCESS';
export const GET_CONFIG_FAILURE = 'customeventdefaultGET_CONFIG_FAILURE';
export const GET_DUPLICATE_REQUESTED = 'customeventdefaultGET_DUPLICATE_REQUESTED';
export const GET_DUPLICATE_SUCCESS = 'customeventdefaultGET_DUPLICATE_SUCCESS';
export const GET_DUPLICATE_FAILURE = 'customeventdefaultGET_DUPLICATE_FAILURE';
export const UPDATE_FIELD = 'customeventdefaultUPDATE_FIELD';
export const UPDATE_PAGE = 'customeventdefaultUPDATE_PAGE';
export const UPDATE_TABLE_FIELD = 'customeventdefaultUPDATE_TABLE_FIELD';
export const UPDATE_RESULT_FIELD = 'customeventdefaultUPDATE_RESULT_FIELD';
export const UPDATE_APPCONFIG_FIELD = 'customeventdefaultUPDATE_APPCONFIG_FIELD';

export const UPDATE_LANGUAGE = 'customeventdefaultUPDATE_LANGUAGE';
export const UPDATE_CONFIG_FIELD = 'customeventdefaultUPDATE_CONFIG_FIELD';
export const UPDATE_LOCALIZATION_FLAG = 'customeventdefaultUPDATE_LOCALIZATION_FLAG';
export const UPDATE_ACTIVE_FLAG = 'customeventdefaultUPDATE_ACTIVE_FLAG';
export const CLEAR_STATE = 'customeventdefaultCLEAR_STATE';
export const REMOVE_CONFIG = 'customeventdefaultREMOVE_CONFIG';
export const UPDATE_BUTTON = 'customeventdefaultUPDATE_BUTTON';

export const UPDATE_START_FIELD = 'customeventdefaultUPDATE_START_FIELD';
export const UPDATE_END_FIELD = 'customeventdefaultUPDATE_END_FIELD';
export const UPDATE_COLLAPSE = 'customeventdefaultUPDATE_COLLAPSE';


const initialState = {
  loading: false,
  loaded: false,
  error: false,
  initialValues: {
    fontTitlePositions: [],
    fonts: [],
    fontStrength: [],
    fontSize: [],
    fontFaceOptions: [
      { title: 'Poppins', value: 'poppins' },
      { title: 'Serif', value: 'Serif' },
      { title: 'Sans-serif', value: 'Sans-serif' },
      { title: 'Monospace', value: 'Monospace' },
      { title: 'Cursive', value: 'Cursive' }
    ],
    fontSizeOptions: [
      { title: '15', value: '15' },
      { title: '20', value: '20' },
      { title: '25', value: '25' },
      { title: '30', value: '30' },
      { title: '35', value: '35' },
      { title: '40', value: '40' }
    ],
    fontTitlePosition: [
      {
        title: 'Left',
        value: 'left',
      },
      {
        title: 'Center',
        value: 'center',
      },
      {
        title: 'Right',
        value: 'right',
      },
    ],
    strength: [
      {
        title: 'Regular',
        value: '400',
      },
      {
        title: 'Bold',
        value: '600',
      },
    ],
    thicknessOptions: [
      {
        title: '1',
        value: '1'
      },
      {
        title: '2',
        value: '2'
      },
      {
        title: '3',
        value: '3'
      },
      {
        title: '4',
        value: '4'
      },
      {
        title: '5',
        value: '5'
      },
    ],
    radiusOptions: [
      {
        title: '0%',
        value: '0%'
      },
      {
        title: '5%',
        value: '5%'
      },
      {
        title: '10%',
        value: '10%'
      },
      {
        title: '20%',
        value: '20%'
      },
      {
        title: '30%',
        value: '30%'
      },
    ],
    shadowOptions: [
      {
        title: '0%',
        value: '0%'
      },
      {
        title: '5%',
        value: '5%'
      },
      {
        title: '10%',
        value: '10%'
      },
      {
        title: '15%',
        value: '15%'
      },
      {
        title: '20%',
        value: '20%'
      },
    ],
    spinButtonWidth: [],
    spinButtonRadius: [],
    spinButtonShadow: [],
    fontPositions: [],
    outlineStyles: []
  },
  collapse: {
    titleCont: true,
    backgroundCont: false,
    timerCard: false,
    descriptionCard: false,
    headerCont: false,
    transactionTableCont: false,
    ctaButton: false
  },
  id: '',
  localizationFlag: '',
  activeNavTab: 'English',
  config: {
    localizationconfig: [
      {
        language: 'English',
        backgroundRadio: true,
        headerBackgroundRadio: true,
        title: {
          text: '',
          color: '#ffffff',
          font: {
            size: '20',
            strength: '400',
            family: 'poppins',
            align: 'center',
          },
          position: 'flex-start',
          titleError: '',
          disableSave: false,
          templateName: {
            text: ''
          },
          templateError: '',
        },
        subtitle: {
          text: '',
          color: '#ffffff',
          font: {
            size: '15',
            strength: '400',
            family: 'poppins',
            align: 'center',
          },
          titleError: '',
        },
        code: '',
        url: '',
        isPortrait: true,
        description: '',
        gamePreviews: '',
        assets: {
          cover: '',
          brick: '',
          thumb: '',
          wall: '',
          square: '',
          screens: {
            page: 1,
            perPage: 1,
            list: [],
          },
          coverTiny: '',
          brickTiny: ''
        },
        categories: '',
        showCardTime: {
          text: '',
          color: '#000000',
          font: {
            size: '15',
            strength: '400',
            family: 'poppins',
            align: 'center',
          },
          position: 'flex-start',
          error: '',
        },
        timerFieldNameTexts: {
          daysText: '',
          hoursText: '',
          minutesText: '',
          secondsText: '',
        },
        timerFieldNameError: '',
        descriptionError: '',
        descriptionHeading: {
          text: '',
          color: '#000000',
          font: {
            size: '20',
            strength: '400',
            family: 'poppins',
            align: 'center'
          },
          error: ''
        },
        /*
        description: {
          text: '',
          color: '#000000',
          bgColor: '#ffedb8',
          font: {
            size: '15',
            strength: '400',
            family: 'Serif',
            align: 'center'
          },
          error: '',
          headingsError: ''
        },
        */
        tableRow: {
          text: '',
          color: '#000000',
          bgColor: '#ffffff',
          font: {
            size: '15',
            strength: '400',
            family: 'Serif',
            align: 'center'
          }
        },
        backgroundColor: '#032aa7',
        backgroundImage: {
          image: '',
          imageName: ''
        },
        headerBackgroundColor: '#032aa7',
        rewardIconImage: {
          image: '',
          imageName: ''
        },
        headerBackgroundImage: {
          image: '',
          imageName: ''
        },
        showTimer: true,
        cardThickness: '1',
        cardBackgroundColor: '#ffffff',
        cardRadius: '5px',
        cardBorderColor: '#032aa7',
        cardShadow: '0 1px 3px',
        cardShadowFill: '#6B6B6B40',
        descriptionThickness: '1',
        descriptionBackgroundColor: '#ffffff',
        descriptionRadius: '5px',
        descriptionBorderColor: '#032aa7',
        descriptionShadow: '0 1px 3px',
        descriptionShadowFill: '#6B6B6B40',
        tableHeadingSectionsError: '',
        backgroundError: '',
        buttonNeeded: true,
        buttonConfig: {
          text: '',
          color: '#FF9017',
          textColor: '#ffffff',
          font: {
            size: '15',
            strength: '400',
            family: 'poppins',
            align: 'center'
          },
          width: '50%',
          radius: '5px',
          shadow: '0 1px 3px',
          shadowColor: '#000000',
          outlineNeeded: 'Yes',
          hoverNeeded: 'Yes',
          outline: '#FF9017',
          hoverOver: '#032aa7',
          appLink: '',
          webLink: '',
          buttonTextError: ''
        },
        tags: '',
        editorState: '',
        width: 0,
        height: 0,
        colorMuted: '',
        colorVibrant: '',
        privateAllowed: true,
        scoringFormat: 'best',
        finalUrl: '',
        playMore: false,
        maxPlaysOption: 'maxplays',
        maxPlays: 3,
        maxPlaysError: '',
        resultHandler: 'ParentApp',
        resultText: {
          winningText: {
            img: '',
            imageName: '',
            text: '',
            color: '#000000',
            font: {
              size: '14',
              strength: '400',
              family: 'Arial, sans-serif',
              align: 'center',
            },
            error: '',
            errorImg: ''
          },
          losingText: {
            img: '',
            imageName: '',
            text: '',
            color: '#000000',
            font: {
              size: '14',
              strength: '400',
              family: 'Arial, sans-serif',
              align: 'center',
            },
            error: '',
            errorImg: ''
          }
        }
      }
    ]
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SAVE_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case SAVE_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case SAVE_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case UPDATE_TITLE_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].title = state.config.localizationconfig[i].title
            ? {
              ...state.config.localizationconfig[i].title,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state, ...state.config };
    }
    case UPDATE_SUBTITLE_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].subtitle = state.config.localizationconfig[i].subtitle
            ? {
              ...state.config.localizationconfig[i].subtitle,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_TEMPLATE_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].assets.screens = state.config.localizationconfig[i].assets.screens
            ? {
              ...state.config.localizationconfig[i].assets.screens,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i] = state.config.localizationconfig[i]
            ? {
              ...state.config.localizationconfig[i],
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_TABLE_FIELD: {
      const tableData = { ...state.tableData, ...action.payload };
      return { ...state, tableData };
    }
    case UPDATE_START_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].start = state.config.localizationconfig[i].start
            ? {
              ...state.config.localizationconfig[i].start,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_END_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].end = state.config.localizationconfig[i].end
            ? {
              ...state.config.localizationconfig[i].end,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case GET_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case GET_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case GET_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case GET_DUPLICATE_REQUESTED: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }
    case GET_DUPLICATE_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case GET_DUPLICATE_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case UPDATE_PAGE: {
      const initialData = { ...state.initialData, ...action.payload };
      return { ...state, initialData };
    }
    case UPDATE_RESULT_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].resultText = state.config.localizationconfig[i].resultText
            ? {
              ...state.config.localizationconfig[i].resultText,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_APPCONFIG_FIELD: {
      state.initialValues = state.initialValues
        ? {
          ...state.initialValues,
          ...action.payload,
        }
        : { ...action.payload };
      return { ...state };
    }
    case UPDATE_LOCALIZATION_FLAG: {
      return { ...state, localizationFlag: action.payload };
    }
    case UPDATE_ACTIVE_FLAG: {
      return { ...state, activeNavTab: action.payload };
    }
    case CLEAR_STATE: {
      return { ...initialState };
    }
    case REMOVE_CONFIG: {
      return { ...state, config: action.payload };
    }
    case UPDATE_CONFIG_FIELD: {
      const localizationconfig = [...state.config.localizationconfig, ...action.payload.localizationconfig];
      const config = {
        ...state.config,
        localizationconfig
      };
      return { ...state, config };
    }
    case UPDATE_BUTTON: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i] = state.config.localizationconfig[i]
            ? {
              ...state.config.localizationconfig[i],
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_COLLAPSE: {
      state.collapse = state.collapse
        ? {
          ...state.collapse,
          ...action.payload,
        }
        : { ...action.payload };
      return { ...state };
    }
    default:
      return state;
  }
};


export const updateTitle = (payload) => {
  return {
    type: UPDATE_TITLE_FIELD,
    payload,
  };
};

export const updateSubTitle = (payload) => {
  return {
    type: UPDATE_SUBTITLE_FIELD,
    payload,
  };
};

export const updateTemplate = (payload) => {
  return {
    type: UPDATE_TEMPLATE_FIELD,
    payload,
  };
};

export const updateGameConfig = (payload) => {
  return {
    type: UPDATE_FIELD,
    payload,
  };
};

export const updateField = (payload) => {
  return {
    type: UPDATE_FIELD,
    payload,
  };
};

export const updatePage = (payload) => {
  return {
    type: UPDATE_PAGE,
    payload,
  };
};


// action
export const updateTableFields = (payload) => {
  return {
    type: UPDATE_TABLE_FIELD,
    payload,
  };
};
export const saveGamesConfig = (data) => {
  return {
    types: [SAVE_CONFIG_REQUESTED, SAVE_CONFIG_SUCCESS, SAVE_CONFIG_FAILURE],
    promise: client => client.post('saveGamesConfig', {
      data,
    }),
  };
};

export const getTemplate = (data) => {
  return {
    types: [GET_CONFIG_REQUESTED, GET_CONFIG_SUCCESS, GET_CONFIG_FAILURE],
    promise: client => client.get(`getGameTemplateById?id=${data}`),
  };
};

export const getGames = (data) => {
  return {
    types: [GET_CONFIG_REQUESTED, GET_CONFIG_SUCCESS, GET_CONFIG_FAILURE],
    promise: client => client.get(`getGamesConfig?id=${data}`),
  };
};

export const editGamesConfig = (data, gamificationId) => {
  return {
    types: [SAVE_CONFIG_REQUESTED, SAVE_CONFIG_SUCCESS, SAVE_CONFIG_FAILURE],
    promise: client => client.post(`saveGamesConfig?gameId=${gamificationId}`, {
      data,
    }),
  };
};

export const checkGamesName = (data, id) => {
  return {
    types: [GET_DUPLICATE_REQUESTED, GET_DUPLICATE_SUCCESS, GET_DUPLICATE_FAILURE],
    promise: client => client.get(`checkInfoScreenName?name=${data}&id=${id}`),
  };
};

export const updateResult = (payload) => {
  return {
    type: UPDATE_RESULT_FIELD,
    payload,
  };
};

export const uploadimage = (file, folderName) => {
  const accessToken = window.localStorage.getItem('access_token');
  return {
    types: [UPLOAD_IMAGE_REQUESTED, UPLOAD_IMAGE_SUCCESS, UPLOAD_IMAGE_FAILURE],
    promise: () => upload
      .post(`${APP_CONFIG.CURRENT_GAMIFICATION_HOST_NAME}/gamification/upload`)
      .withCredentials()
      .set({ has_auth_token: 1 })
      .set('Authorization', `Bearer ${accessToken}`)
      .attach('files', file)
      .field('folderName', folderName),
  };
};

export const getAppConfig = () => {
  return {
    types: [GET_CONFIG_REQUESTED, GET_CONFIG_SUCCESS, GET_CONFIG_FAILURE],
    promise: client => client.get('getAppConfig'),
  };
};

export const updateDropdown = (payload) => {
  return {
    type: UPDATE_APPCONFIG_FIELD,
    payload,
  };
};

export const updateLocalizationFlag = (payload) => {
  return {
    type: UPDATE_LOCALIZATION_FLAG,
    payload,
  };
};


export const updateActiveFlag = (payload) => {
  return {
    type: UPDATE_ACTIVE_FLAG,
    payload,
  };
};

export const removeConfig = (payload) => {
  return {
    type: REMOVE_CONFIG,
    payload
  };
};

export const updateLanguage = (payload) => {
  return {
    type: UPDATE_LANGUAGE,
    payload
  };
};

export const clearState = () => {
  return {
    type: CLEAR_STATE,
  };
};

export const updateConfig = (payload) => {
  return {
    type: UPDATE_CONFIG_FIELD,
    payload
  };
};

export const updateButton = (payload) => {
  return {
    type: UPDATE_BUTTON,
    payload
  };
};

export const updateStart = (payload) => {
  return {
    type: UPDATE_START_FIELD,
    payload,
  };
};

export const saveCustomEventConfig = (data) => {
  return {
    types: [SAVE_CONFIG_REQUESTED, SAVE_CONFIG_SUCCESS, SAVE_CONFIG_FAILURE],
    promise: client => client.post('saveInfoScreenPageConfig', {
      data,
    }),
  };
};

export const getCustomEventConfig = (id) => {
  return {
    types: [GET_CONFIG_REQUESTED, GET_CONFIG_SUCCESS, GET_CONFIG_FAILURE],
    promise: client => client.get(`getInfoScreenPageConfig?pageId=${id}`),
  };
};

export const updateEnd = (payload) => {
  return {
    type: UPDATE_END_FIELD,
    payload,
  };
};

export const updateCollapse = (payload) => {
  return {
    type: UPDATE_COLLAPSE,
    payload
  };
};
